export { default as ApplicationSettingEditTemplate } from './ApplicationSettingEdit'; 